import { render } from "./AppButton.vue?vue&type=template&id=2589934e&scoped=true"
import script from "./AppButton.vue?vue&type=script&lang=js"
export * from "./AppButton.vue?vue&type=script&lang=js"

import "./AppButton.vue?vue&type=style&index=0&id=2589934e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2589934e"]])

export default __exports__